/**
 * Program: SDL Common Directive
 * Author: SDL
 * Description: SDL Common Directive List
 */
import custom from './custom';
import clickOutSide from './clickOutside';
import regex from './regex';
import authorization from './authorization';
import validation from './validation';

export default {
  install(Vue) {
    Vue.directive('custom', custom);
    Vue.directive('click-outside', clickOutSide);
    Vue.directive('regex', regex);
    Vue.directive('authorization', authorization);
    Vue.directive('validation', validation);
  },
};



// WEBPACK FOOTER //
// ./src/directives/index.js